import React from "react";
import { useNavigate } from "react-router-dom";
import { updateLocalStorageAccInfo } from "services/auth_service";

import { useParams } from "react-router";
import { Link } from "react-router-dom";

import RightAdd from "components/RightAdd";
import TopAdd from "components/TopAdd";
import Topnav from "components/Topnav";

import { deleteTeam } from "services/teams_service";

function App() {
  const { equipaId } = useParams();
  const navigate = useNavigate();

  const submitForm = async () => {
    await deleteTeam(equipaId);
    await updateLocalStorageAccInfo();

    navigate(`/equipas`);
  };

  return (
    <div className="geral">
      <div className="App">
        <Topnav></Topnav>
        <div className="conteudo">
        <TopAdd></TopAdd>
        <div style={{"display": "flex"}}>

          <section className="section dashboard">
            <nav className="breadcrumb" aria-label="breadcrumbs">
              <ul>
                <Link to={"/equipas"}>Plantel</Link> / Detalhe
              </ul>
            </nav>

            <div className="geral">
              <div className="hero is-footsolution">
                <div className="columns">
                  <div className="column">
                    <h1 className="title is-3">Remover plantéis</h1>
                  </div>
                </div>
              </div>
            </div>

            <div className="columns">
              <div className="column">
                  <div className="block">
                    <div className="field">
                      Está a remover o plantel. Se o remover toda a informação deste plantel será perdida.
                    </div>
                  </div>

                  <button onClick={() => submitForm()} className="button is-danger">Apagar</button>
              </div>
            </div>
          </section>

          <RightAdd></RightAdd>
         </div>
        </div>
      </div>
    </div>
  );
}

export default App;
